var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73057 5.01081H12.5908V13.8347C12.5908 14.0148 12.5193 14.1874 12.392 14.3147C12.2647 14.442 12.092 14.5135 11.912 14.5135H2.40934C2.22932 14.5135 2.05667 14.442 1.92938 14.3147C1.80209 14.1874 1.73057 14.0148 1.73057 13.8347V5.01081ZM3.0881 6.36834V13.156H11.2333V6.36834H3.0881ZM5.12439 7.72587H6.48192V11.7984H5.12439V7.72587ZM7.83945 7.72587H9.19697V11.7984H7.83945V7.72587ZM3.76686 2.97452V1.617C3.76686 1.43698 3.83838 1.26433 3.96567 1.13704C4.09296 1.00974 4.26561 0.938232 4.44563 0.938232H9.87574C10.0558 0.938232 10.2284 1.00974 10.3557 1.13704C10.483 1.26433 10.5545 1.43698 10.5545 1.617V2.97452H13.9483V4.33205H0.373047V2.97452H3.76686ZM5.12439 2.29576V2.97452H9.19697V2.29576H5.12439Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.022b97cf9449f92b3bc43f9b91b54e7b.svg";
export { ForwardRef as ReactComponent };